/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import TimePrimitive from "../../primitive/TimePrimitive"
import { defaultPrimitive, ILandingPrimitive } from "src/modules/pe-landing-module/data/interfaces"

const CardFieldTime = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    useEffect(() => { 
            addCSSClass(
                `landing-card-field-time-${section.id + "-" + value?.id}`,
                `.landing-card-field-time-${section.id + "-" + value?.id} {
                    
                } 
                `
            )
            return () => removeCSSClass(`landing-card-field-time-${section.id + "-" + value?.id}`)
        }, []) 
    
    const primitive: ILandingPrimitive = {
            ...defaultPrimitive(),
        ...field,
        ...value, 
        data: {...field.data, ...value.data},
        style: { ...field.style, ...value.style },
        position: {
            ...field.position, 
        },
        id: section.id + "-" + value?.id,
    }
    
    return <div 
        className={`landing-card-field landing-card-field-time landing-card-field-time-${section.id + "-" + value.id} ${value.className}`}  
        style={{ 
            ...field.style, 
            ...value.style,
            width: field.width, 
            height: field.height, 
        }}
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >  
        <TimePrimitive
            primitive={primitive}
        />
    </div>
}
export default CardFieldTime